<template>
  <div>
    <v-row class="pb-6">
      <v-col cols="12">
        <p class="primary--text form__title">
          VISUALIZAR DADOS DA COTAÇÃO
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="4" class="pr-sm-5">
        <p class="form__label primary--text mb-2">
          Tomador Matriz/Filial
        </p>
        <p class="body-2 primary--text mb-7">
          {{ form.tomador.nome_fantasia }}
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="4" class="pr-sm-5">
        <p class="form__label primary--text mb-2">
          CNPJ
        </p>
        <p class="body-2 primary--text mb-7">
          {{ form.tomador.cnpj }}
        </p>
      </v-col>
      <v-col cols="12" class="pt-3">
        <v-divider />
      </v-col>
    </v-row>
    <v-row class="pb-6">
      <v-col cols="12">
        <p class="font-weight-bold primary--text form__title">
          SEGURADO
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="4" class="pr-0 pr-sm-5">
        <p class="form__label primary--text mb-2">
          Tipo
        </p>
        <p class="body-2 primary--text mb-7">
          {{ form.segurado.tipo_pessoa.nome }}
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="4" class="pr-0 pr-md-5">
        <p class="form__label primary--text mb-2">
          CPF/CNPJ
        </p>
        <p class="body-2 primary--text mb-7">
          {{ form.segurado.numero_documento }}
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="4" class="pr-0 pr-sm-5 pr-md-0">
        <p class="form__label primary--text mb-2">
          Nome
        </p>
        <p class="body-2 primary--text mb-7">
          {{ form.segurado.nome }}
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="2" class="pr-0 pr-md-5">
        <p class="form__label primary--text mb-2">
          CEP
        </p>
        <p class="body-2 primary--text mb-7">
          {{ form.segurado.endereco.cep }}
        </p>
      </v-col>
      <v-col cols="12" sm="6" class="pr-0 pr-sm-5">
        <p class="form__label primary--text mb-2">
          Endereço
        </p>
        <p class="body-2 primary--text mb-7">
          {{ form.segurado.endereco.logradouro }}
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="2" class="pr-0 pr-md-5">
        <p class="form__label primary--text mb-2">
          Número
        </p>
        <p class="body-2 primary--text mb-7">
          {{ form.segurado.endereco.numero }}
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="2" class="pr-0 pr-sm-5 pr-md-0">
        <p class="form__label primary--text mb-2">
          Complemento
        </p>
        <p class="body-2 primary--text mb-7">
          {{ form.segurado.endereco.complemento }}
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="4" class="pr-0 pr-md-5">
        <p class="form__label primary--text mb-2">
          UF
        </p>
        <p class="body-2 primary--text mb-7">
          {{ form.segurado.endereco.uf.nome }}
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="4" class="pr-0 pr-sm-5">
        <p class="form__label primary--text mb-2">
          Cidade
        </p>
        <p class="body-2 primary--text mb-7">
          {{ form.segurado.endereco.cidade }}
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <p class="form__label primary--text mb-2">
          Bairro
        </p>
        <p class="body-2 primary--text mb-7">
          {{ form.segurado.endereco.bairro }}
        </p>
      </v-col>
      <v-col cols="12" class="pt-3">
        <v-divider />
      </v-col>
    </v-row>
    <v-row class="pb-6">
      <v-col cols="12">
        <p class="font-weight-bold primary--text form__title">
          EMISSÃO
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="4" class="pr-sm-5">
        <p class="form__label primary--text mb-2">
          Tipo de emissão
        </p>
        <p class="body-2 primary--text mb-7">
          {{ form.tipo_emissao.nome }} - {{ form.submodalidade.nome }}
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="4" class="pr-sm-5">
        <p class="form__label primary--text mb-2">
          Tipo do processo
        </p>
        <p class="body-2 primary--text mb-7">
          {{ nameProcess }}
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="4" class="pr-lg-5">
        <p class="form__label primary--text mb-2">
          Número do Processo
        </p>
        <p class="body-2 primary--text mb-7">
          {{ numberProcess }}
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="4" class="pr-md-5">
        <p class="form__label primary--text mb-2">
          {{ nameLabelCourt }}
        </p>
        <p class="body-2 primary--text mb-7">
          {{ nameCourt }}
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="4" class="pr-md-5">
        <p class="form__label primary--text mb-2">
          {{ nameLabelJusticeRegion }}
        </p>
        <p class="body-2 primary--text mb-7">
          {{ nameJusticeRegion }}
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="4" class="pr-md-5">
        <p class="form__label primary--text mb-2">
          Nº Interno Cliente
        </p>
        <p class="body-2 primary--text mb-7">
          {{ form.numero_controle_interno }}
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="4" class="pr-md-5">
        <p class="form__label primary--text mb-2">
          Escritório Responsável
        </p>
        <p class="body-2 primary--text mb-7">
          {{ nameOffice }}
        </p>
      </v-col>
      <v-col cols="12" class="pt-3">
        <v-divider />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <p class="font-weight-bold primary--text form__title">
          {{ nameTypeQuotation }}
        </p>
      </v-col>
    </v-row>
    <div v-for="(element, key) of form.recursos" :key="key" class="pb-6">
      <v-row>
        <v-col cols="12" sm="6" md="4" class="pr-sm-5">
          <p class="form__label primary--text mb-2">
            Tipo de Recurso
          </p>
          <p class="body-2 primary--text mb-7">
            {{ element.tipo_recurso.nome }}
          </p>
        </v-col>
        <v-col cols="12" sm="6" md="4" class="pr-md-5">
          <p class="form__label primary--text mb-2">
            Valor de Depósito Recursal e Agravo
          </p>
          <p class="body-2 primary--text mb-7">
            {{ asMoneyString(element.valor_deposito_recursal) }} + 30% de Agravo
          </p>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <p class="form__label primary--text mb-2">
            Importância Segurada
          </p>
          <p class="body-2 primary--text mb-7">R$ {{ calcInsuredAmount }}</p>
        </v-col>
        <v-col cols="12" class="pt-3">
          <v-divider />
        </v-col>
      </v-row>
    </div>
    <v-row class="pb-6" v-if="form.recursos.length == 0">
      <v-col cols="12" sm="6" md="4" class="pr-sm-5">
        <p class="form__label primary--text mb-2">
          Valor
        </p>
        <p class="body-2 primary--text mb-7">
          {{ asMoneyString(form.valor_importancia_segurada) }}
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="4" class="pr-sm-5">
        <p class="form__label primary--text mb-2">
          Composição da Importância Segurada
        </p>
        <p class="body-2 primary--text mb-7">
          {{ form.composicao_importancia_segurada }}
        </p>
      </v-col>
      <v-col cols="12" class="pt-3">
        <v-divider />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="10">
        <p class="gray--text font-weight-bold form__title">
          PRAZOS
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="4" class="pr-sm-5 pb-5 pb-sm-0">
        <p class="form__label primary--text mb-2">
          Início de vigência
        </p>
        <p class="body-2 primary--text mb-7">DE 24HRS DE {{ startTerm }}</p>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <p class="form__label primary--text mb-2">
          Término de vigência:
        </p>
        <p class="body-2 primary--text mb-7">DE 24HRS DE {{ endTerm }}</p>
      </v-col>
      <v-col cols="12" class="pt-3">
        <v-divider />
      </v-col>
    </v-row>
    <v-row class="pb-6 pt-8">
      <v-col cols="12" v-if="form.anexos.length > 0">
        <p class="font-weight-bold primary--text form__title">
          DOCUMENTOS ANEXOS
        </p>
      </v-col>
      <v-col>
        <DocumentDataTable
          :documents="form.anexos"
          @preview-file="onPreviewFile"
          :disabled="true"
        />
      </v-col>
    </v-row>
    <BaseFooter>
      <v-row>
        <v-spacer />
        <v-col cols="12" sm="5" md="3" xl="2">
          <BaseButton
            v-html="'VOLTAR'"
            class="white--text secondary"
            width="100%"
            @click="returnQuotation"
          />
        </v-col>
      </v-row>
    </BaseFooter>
  </div>
</template>
<script>
import { format, addYears } from "date-fns";
import { asMoneyString } from "@/utils/formats.js";
import LabelInputMixin from "@/mixins/LabelInputMixin";
import DocumentDataTable from "@/components/DocumentDataTable";
import DocumentsMixin from "@/mixins/DocumentsMixin";
import _ from "lodash";
export default {
  data: () => ({
    startTerm: "DD/MM/AAAA",
    endTerm: "DD/MM/AAAA",
    asMoneyString
  }),
  components: {
    DocumentDataTable
  },
  mixins: [LabelInputMixin, DocumentsMixin],
  mounted() {
    this.updateIntervalDate();
  },
  computed: {
    nameOffice() {
      return this.form.escritorio?.nome_fantasia || "NENHUM";
    },
    numberProcess() {
      return this.form.processo?.numero_processo || "";
    },
    nameProcess() {
      return this.form.processo?.tipo_processo?.nome || "";
    },
    nameCourt() {
      return (
        this.form.processo?.tribunal?.nome ||
        this.form.processo?.nome_tribunal ||
        ""
      );
    },
    nameJusticeRegion() {
      return (
        this.form.processo?.unidade?.nome ||
        this.form.processo?.nome_unidade ||
        ""
      );
    },
    nameTypeQuotation() {
      return this.form.recursos.length == 0
        ? "IMPORTÂNCIA SEGURADA"
        : "RECURSOS";
    },
    calcInsuredAmount: {
      get() {
        // por hora esta fazendo apenas para o primeiro
        // pois só tem um, pensar como fazer no futuro
        // quando tiver mais casos
        if (this.form.recursos[0].valor_deposito_recursal) {
          const convertValue = _.isString(
            this.form.recursos[0].valor_deposito_recursal
          )
            ? parseFloat(
                this.form.recursos[0].valor_deposito_recursal.replace(
                  /[\D]+/g,
                  ""
                )
              ) / 100
            : this.form.recursos[0].valor_deposito_recursal;
          return asMoneyString(convertValue + convertValue * 0.3);
        } else {
          return "R$ 0,00";
        }
      },
      set(value) {
        this.form.insuredAmount = value;
      }
    },
    isModalityJudicial() {
      return this.form.modalidade.id === "judicial";
    }
  },
  methods: {
    returnQuotation() {
      this.$emit("return");
    },
    updateIntervalDate() {
      // Trocar valores apenas quando a data
      // estiver no formato correto
      const [year, month, day] = this.form.inicio_vigencia.split("-");
      this.startTerm = `${day}/${month}/${year}`;
      // no Date ele considera no mês de 0 até 11, em vez de 1 a 12
      let endDate = addYears(new Date(year, month - 1, day), this.form.prazo);
      this.endTerm = format(endDate, "dd/MM/yyyy");
    }
  },
  props: {
    form: {
      type: Object
    }
  }
};
</script>
